import { z } from 'zod';

export const classPerformanceItemSchema = z.object({
  rotulo: z.string(),
  pontuacao: z.number(),
});

export type ClassPerformanceItem = z.infer<typeof classPerformanceItemSchema>;

export const classPerformanceResponseSchema = z.object({
  metaEscola: z.number(),
  turmas: z.array(classPerformanceItemSchema),
  interpretacao: z.string().optional(),
});

export type ClassPerformanceResponse = z.infer<typeof classPerformanceResponseSchema>;
